// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TradeLinkHelp_wrapper__9xG6L {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz {
  background-color: #1B1E23;
  border-radius: 4px;
  color: #FFFFFF;
  max-width: 800px;
  width: 90%;
  padding: 20px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_title__lLhDX {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  margin-bottom: 24px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_subtitle__ubLR- {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  margin-bottom: 16px;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-bottom: 8px;
  padding-left: 16px;
  position: relative;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP span {
  color: #FFFFFF;
  font-weight: 500;
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP .TradeLinkHelp_listImage__nHijV {
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_btn__Uk8\\+g {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

@media (max-width: 850px) {
  .TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_subtitle__ubLR- {
    font-size: 16px;
  }
  .TradeLinkHelp_wrapper__9xG6L .TradeLinkHelp_container__ZzbUz .TradeLinkHelp_list__NEymO .TradeLinkHelp_listItem__l5daP {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TradeLinkHelp/TradeLinkHelp.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,oCAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AADF;AAGE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;AADJ;AAGI;ECTF,eAAA;EACA,gBAAA;EACA,kBAAA;EDUI,mBAAA;AAAN;AAGI;ECSF,eAAA;EACA,gBAAA;EACA,kBAAA;EDRI,mBAAA;AAAN;AAKM;ECOJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDNM,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAFR;AAIQ;EACE,cAAA;EACA,gBAAA;AAFV;AAKQ;EACE,OAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAHV;AAQI;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;AANN;;AAYA;EAKM;IACE,eAAA;EAbN;EAkBM;IACE,eAAA;EAhBR;AACF","sourcesContent":["@import '../../assets/styles/global.scss';\n\n.wrapper {\n  align-items: center;\n  background-color: rgba(0, 0, 0, .5);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1;\n\n  .container {\n    background-color: #1B1E23;\n    border-radius: 4px;\n    color: #FFFFFF;\n    max-width: 800px;\n    width: 90%;\n    padding: 20px;\n\n    .title {\n      @include h3;\n      \n      margin-bottom: 24px;\n    }\n\n    .subtitle {\n      @include subtitle4m;\n\n      margin-bottom: 16px;\n    }\n\n    .list {\n\n      .listItem {\n        @include subtitle5;\n\n        color: #E0E0E0;\n        margin-bottom: 8px;\n        padding-left: 16px;\n        position: relative;\n\n        span {\n          color: #FFFFFF;\n          font-weight: 500;\n        }\n\n        .listImage {\n          left: 0;\n          position: absolute;\n          top: 50%;\n          transform: translateY(-50%);\n        }\n      }\n    }\n\n    .btn {\n      display: flex;\n      justify-content: end;\n      margin-top: 20px;\n    }\n  }\n}\n\n\n@media (max-width: 850px) {\n  .wrapper {\n\n    .container {\n\n      .subtitle {\n        font-size: 16px;\n      }\n\n      .list {\n\n        .listItem {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `TradeLinkHelp_wrapper__9xG6L`,
	"container": `TradeLinkHelp_container__ZzbUz`,
	"title": `TradeLinkHelp_title__lLhDX`,
	"subtitle": `TradeLinkHelp_subtitle__ubLR-`,
	"list": `TradeLinkHelp_list__NEymO`,
	"listItem": `TradeLinkHelp_listItem__l5daP`,
	"listImage": `TradeLinkHelp_listImage__nHijV`,
	"btn": `TradeLinkHelp_btn__Uk8+g`
};
export default ___CSS_LOADER_EXPORT___;
